import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-0 flex-1 overflow-auto rounded-2xl border border-[#E5E7EB] bg-white shadow-sm" }
const _hoisted_2 = { class: "min-w-[720px] divide-y divide-[#E5E7EB] text-left text-sm" }
const _hoisted_3 = { class: "sticky top-0 bg-[#F8FAFC] text-xs uppercase tracking-wider text-[#626468]" }
const _hoisted_4 = { class: "px-5 py-4" }
const _hoisted_5 = { class: "px-5 py-4" }
const _hoisted_6 = { class: "px-5 py-4" }
const _hoisted_7 = { class: "px-5 py-4" }
const _hoisted_8 = { class: "px-5 py-4 text-right" }
const _hoisted_9 = { class: "px-5 py-4 text-right" }
const _hoisted_10 = { class: "divide-y divide-[#F1F3F5]" }
const _hoisted_11 = { class: "px-5 py-4" }
const _hoisted_12 = { class: "font-semibold text-[#242B59]" }
const _hoisted_13 = { class: "mt-1 text-xs text-[#626468]" }
const _hoisted_14 = { class: "px-5 py-4" }
const _hoisted_15 = { class: "font-medium text-[#242B59]" }
const _hoisted_16 = { class: "max-w-xs truncate text-xs text-[#626468]" }
const _hoisted_17 = { class: "whitespace-nowrap px-5 py-4 text-[#626468]" }
const _hoisted_18 = { class: "px-5 py-4" }
const _hoisted_19 = { class: "px-5 py-4 text-right text-[#626468]" }
const _hoisted_20 = { class: "px-5 py-4 text-right font-semibold text-[#242B59]" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  colspan: "6",
  class: "px-5 py-12 text-center text-sm text-[#626468]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('aura.processingCosts.table.processing')), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('aura.processingCosts.table.userConversation')), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('aura.processingCosts.table.date')), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('aura.processingCosts.table.status')), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('aura.processingCosts.table.tokens')), 1 /* TEXT */),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('aura.processingCosts.table.cost')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("tbody", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "hover:bg-[#F8FAFC]"
          }, [
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString($setup.formatProcessingLabel(item)), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_13, _toDisplayString($setup.translateSourceType(item.sourceType)), 1 /* TEXT */)
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(item.conversation?.userName ||
                                _ctx.$t('aura.processingCosts.systemProcessing')), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_16, _toDisplayString(item.conversation?.title ||
                                _ctx.$t('aura.processingCosts.noConversation')), 1 /* TEXT */)
            ]),
            _createElementVNode("td", _hoisted_17, _toDisplayString($props.formatDate(item.startedAt)), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("span", {
                class: _normalizeClass(["rounded-full px-2 py-1 text-xs font-semibold", $setup.getStatusClass(item.status)])
              }, _toDisplayString($setup.translateStatus(item.status)), 3 /* TEXT, CLASS */)
            ]),
            _createElementVNode("td", _hoisted_19, _toDisplayString(item.tokensUsed || 0), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_20, _toDisplayString($props.formatCost(item.costUsd)), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        (!$props.isLoading && !$props.items.length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t('aura.processingCosts.empty')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}